import SpriteSymbol from "../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../shared/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-search\"><path fill=\"currentColor\" d=\"M21.94 20.27L27 25.327 25.328 27l-5.059-5.06a10.58 10.58 0 01-6.636 2.326C7.763 24.266 3 19.503 3 13.633 3 7.763 7.764 3 13.633 3c5.87 0 10.633 4.764 10.633 10.633a10.58 10.58 0 01-2.326 6.636zm-2.37-.877a8.24 8.24 0 002.333-5.76c0-4.57-3.701-8.27-8.27-8.27-4.57 0-8.27 3.7-8.27 8.27 0 4.569 3.7 8.27 8.27 8.27a8.244 8.244 0 005.76-2.333l.177-.177z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol